import api from './api'

export default {
  list() {
    return api.get('/clients')
  },
  create(data) {
    return api.post('/clients', data)
  },
  destroy(id) {
    return api.delete(`/clients/${id}`)
  },
  activate(id) {
    return api.post(`/clients/${id}/enable`)
  },
  deactivate(id) {
    return api.post(`/clients/${id}/disable`)
  },
}
